import React from 'react';
import _ from 'lodash';
import {InlineSelect} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import REST from 'go/requests/rest';

const defaultSelected = {
  text: 'Select',
  value: null,
  key: 'select-default',
};
const INVENTORY_ITEM_PATH = ['inventoryItem'];
const LOCATION_COUNTY_PATH = ['location', 'county'];
const LOCATION_STATE_PATH = ['location', 'state'];

export class CountyDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  getCountyOptions = () => {
    const {token} = this.props;
    const stateCode = _.get(
      this.props,
      _.concat(INVENTORY_ITEM_PATH, LOCATION_STATE_PATH)
    );
    if (!_.isEmpty(stateCode)) {
      REST.ref
        .getCountiesByState(stateCode, token)
        .then((res) => res.json())
        .then((countiesList) => {
          const countyOptions = _.map(countiesList, (county) => {
            const {countyName} = county;
            return {
              key: countyName,
              text: countyName,
              value: countyName,
            };
          });
          this.setState({
            countyOptions: countyOptions,
          });
        });
    } else {
      this.setState({
        countyOptions: [],
      });
    }
  };

  componentDidMount = () => {
    this.getCountyOptions(
      _.get(this.props, _.concat(INVENTORY_ITEM_PATH, LOCATION_STATE_PATH))
    );
  };

  componentDidUpdate = (prevProps) => {
    const invLocStatePath = _.concat(INVENTORY_ITEM_PATH, LOCATION_STATE_PATH);
    if (
      !_.isEqual(
        _.get(this.props, _.concat(invLocStatePath)),
        _.get(prevProps, invLocStatePath)
      )
    ) {
      this.getCountyOptions();
    }
    const {countyOptions} = this.state;
    const locCounty = _.get(
      this.props,
      _.concat(INVENTORY_ITEM_PATH, LOCATION_COUNTY_PATH)
    );
    if (
      !_.isEmpty(countyOptions) &&
      !_.isEmpty(locCounty) &&
      _.findIndex(countyOptions, (county) => county.value === locCounty) === -1
    ) {
      this.props.saveValue(_.join(LOCATION_COUNTY_PATH, '.'), null);
    }
  };

  render() {
    const {
      id,
      label,
      ariaLabel,
      name,
      value,
      displayType,
      inventoryItem = {},
    } = this.props;
    const {countyOptions = []} = this.state;

    const {location} = inventoryItem;
    return (
      <div id="location-county">
        {displayType === 'view' ? (
          <React.Fragment>
            <p className="label">{label}</p>
            {location.county}
          </React.Fragment>
        ) : (
          <div className="util--full-width ui form">
            {countyOptions && (
              <InlineSelect
                id={id}
                label={label}
                aria-label={ariaLabel}
                name={name}
                options={[defaultSelected, ...countyOptions]}
                disabled={_.size(countyOptions) === 0 || _.isEmpty(location.state)}
                value={value || _.get(location, name)}
                handleChange={this.props.handleChange}
                handleBlur={this.props.handleBlur}
                displayError={this.props.displayError('location.county')}
                errorMessages={this.props.getErrorMessage(name, 'County')}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default CountyDropdown;
